import React from "react"
import { Container, Row, Button } from "reactstrap"
import "bootstrap/dist/css/bootstrap.min.css"

const Home = () => {
  // const lurl = "http://localhost:3000"
  const lurl = "https://pmapp.prisms.in"

  const sid = localStorage.getItem("sid").replace(/"/g, "")
  const staff_id = localStorage.getItem("user_id")

  const handleSubmit = () => {
    const url = new URL(
      `${lurl}/transport/pickup/student/` + sid + "/" + staff_id
    )
    url.searchParams.set("attendType", "pickup")
    window.location.href = url.toString()
  }

  const handleSubmitDrop = () => {
    const url = new URL(
      `${lurl}/transport/pickup/student/` + sid + "/" + staff_id
    )
    url.searchParams.set("attendType", "drop")
    window.location.href = url.toString()
  }

  const handleSubmitRFID = () => {
    const url = new URL(
      `${lurl}/transport/pickup/student/` + sid + "/" + staff_id
    )
    url.searchParams.set("attendType", "pickup")
    url.searchParams.set("rfid", "rfid")

    window.location.href = url.toString()
  }

  const handleSubmitDropRFID = () => {
    const url = new URL(
      `${lurl}/transport/pickup/student/` + sid + "/" + staff_id
    )
    url.searchParams.set("attendType", "drop")
    url.searchParams.set("rfid", "rfid")
    window.location.href = url.toString()
  }
  return (
    <div className="page-content px-0" style={{ paddingTop: "70px" }}>
      <div
        style={{
          width: "100%",
          height: "85vh",
          backgroundColor: "#211689",
          //   padding: "20px",
        }}
      >
        <Container>
          <Row>
            <h1 className="text-white fs-4 text-center mt-3 mb-4">
              Transport <br /> Attendance
            </h1>

            <div className="text-center mb-4">
              <i className="fas fa-bus-alt fa-3x text-white"></i>
            </div>

            <div className="text-center mb-4">
              <i className="fas fa-qrcode fa-3x text-white"></i>
            </div>

            <div className="text-center mb-3">
              <Button
                color="light"
                style={{ width: "250px", borderRadius: "50px" }}
                onClick={handleSubmit}
              >
                QR Pickup Attendance
              </Button>
              {/* <Button
                color="light"
                style={{
                  width: "250px",
                  borderRadius: "50px",
                  marginTop: "10px",
                }}
                onClick={handleSubmitRFID}
              >
                RFID Pickup Attendance
              </Button> */}
            </div>

            <div className="text-center mb-4">
              <Button
                color="light"
                style={{ width: "250px", borderRadius: "50px" }}
                onClick={handleSubmitDropRFID}
              >
                QR Drop Attendance
              </Button>
              {/* <Button
                color="light"
                style={{
                  width: "250px",
                  borderRadius: "50px",
                  marginTop: "10px",
                }}
                onClick={handleSubmitDrop}
              >
                RFID Drop Attendance
              </Button> */}
              {/* </Link> */}
            </div>

            <hr
              className="bg-light"
              style={{ width: "200px", margin: "auto" }}
            />

            <div className="text-center my-4">
              <i className="fas fa-book fa-3x text-white"></i>
            </div>

            <div className="text-center mb-3">
              <Button
                color="light"
                style={{ width: "280px", borderRadius: "50px" }}
              >
                Manual Pickup Attendance
              </Button>
            </div>

            <div className="text-center">
              <Button
                color="light"
                style={{ width: "280px", borderRadius: "50px" }}
              >
                Manual Drop Attendance
              </Button>
            </div>
          </Row>
        </Container>
      </div>
    </div>
  )
}

export default Home
